import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { AuthContext } from "./AuthContext";
import {
  fetchOnboardingProgress,
  skipOnboardingStep,
  resetOnboarding,
} from "./onboardingApi";

export const OnboardingContext = createContext(null);

function isAdminRole(role) {
  const r = String(role || "").toLowerCase();
  return r === "admin" || r === "superadmin" || r === "super_admin";
}

export default function OnboardingProvider({ children }) {
  const { role } = useContext(AuthContext);
  const [progress, setProgress] = useState(null);
  const [loading, setLoading] = useState(false);

  const refetch = useCallback(async () => {
    if (!isAdminRole(role)) return;
    setLoading(true);
    try {
      const data = await fetchOnboardingProgress();
      setProgress(data);
    } catch {
      // Non-fatal — widget simply stays hidden
    } finally {
      setLoading(false);
    }
  }, [role]);

  useEffect(() => {
    if (isAdminRole(role)) refetch();
  }, [role, refetch]);

  const skipStep = useCallback(
    async (stepKey) => {
      await skipOnboardingStep(stepKey);
      await refetch();
    },
    [refetch]
  );

  const reset = useCallback(async () => {
    await resetOnboarding();
    await refetch();
  }, [refetch]);

  return (
    <OnboardingContext.Provider
      value={{ progress, loading, refetch, skipStep, reset }}
    >
      {children}
    </OnboardingContext.Provider>
  );
}
